import React from "react";
import { useAuth } from "../contexts/AuthContext";
import NotFound from "./NotFound";

// Generic role route guard, mirroring AdminRoute. anyOf is a list of the role
// keys the surface accepts: a content section role, MANAGER for manager-tier
// surfaces, or a structural role that gates a surface of its own, the way
// App.js passes [CONVERSATIONS, MANAGER] for the conversations screen.
// All-access (admin) always passes via canSeeSection. Renders NotFound to
// avoid revealing that the route exists. Advisory only: the backend
// enforces the real access control on every API call.
const RoleRoute = ({ anyOf, allow, children }) => {
  const { isAuthenticated, canSeeSection, user } = useAuth();

  if (!isAuthenticated) {
    return <NotFound />;
  }

  const okByRole = (anyOf || []).some((role) => canSeeSection(role));
  const okByAllow = typeof allow === "function" && allow(user?.roles);
  if (!okByRole && !okByAllow) {
    return <NotFound />;
  }

  return children;
};

export default RoleRoute;
